import { clsx } from "clsx";
import { Children, CSSProperties, FC, HTMLAttributes, ReactNode } from "react";
import classes from "./SimpleCard.module.less";

export type SimpleCardType = "default" | "white" | "primary" | "success";
export type SimpleCardHeaderType = "default" | "primary" | "success";

export interface SimpleCardProps extends HTMLAttributes<HTMLDivElement> {
    header?: ReactNode;
    type?: SimpleCardType;
    headerType?: SimpleCardHeaderType;
    bodyClassName?: string;
    bodyStyle?: CSSProperties;
    headerClassName?: string;
    headerStyle?: CSSProperties;
}

export const SimpleCard: FC<SimpleCardProps> = ({
    header,
    className,
    type = "default",
    headerType = "default",
    children,
    bodyClassName,
    bodyStyle,
    headerClassName,
    headerStyle,
    ...restProps
}) => {
    return (
        <div {...restProps} className={clsx(classes.Card, classes[`Card--${type}`], className)}>
            {header && (
                <div
                    className={clsx(
                        headerClassName,
                        classes.CardHeader,
                        classes[`CardHeader--${headerType}`]
                    )}
                    style={headerStyle}
                >
                    {header}
                </div>
            )}
            {Children.count(children) > 0 && (
                <div className={clsx(bodyClassName, classes.CardBody)} style={bodyStyle}>
                    {children}
                </div>
            )}
        </div>
    );
};

SimpleCard.displayName = "Card";
